<template>
	<ElDropdown
		class="new-view"
		trigger="click"
		placement="bottom-start"
		@command="newView"
	>
		<CToolTip placement="top" :open-delay="600" role="none" class="new-view__button p-3 rounded-full hover:bg-hovered">
			<template #button>
				<Inline svg="plus" aria-label="New View" class="block text-icon-intense" />
			</template>
			<span>New View</span>
		</CToolTip>

		<ElDropdownMenu class="font-bold">
			<div class="new-view__dropdown-title font-display text-0 uppercase text-subtle">Create a view</div>

			<ElDropdownItem class="flex flex-col" command="Table">
				<span class="text-intense flex items-center gap-3">
					<Inline class="text-icon-intense" svg="grid" /> New Grid View
				</span>
				<span class="new-view__helptext helptext font-normal">
					Table format
				</span>
			</ElDropdownItem>

			<ElDropdownItem class="flex flex-col" command="Task">
				<span class="text-intense flex items-center gap-3">
					<Inline class="text-icon-intense" svg="task-grid" /> New Task View
				</span>
				<span class="new-view__helptext helptext font-normal">
					Assign tasks
				</span>
			</ElDropdownItem>

			<ElDropdownItem class="flex flex-col" command="Form">
				<span class="text-intense flex items-center gap-3">
					<Inline class="text-icon-intense" svg="form-view" /> New Form View
				</span>
				<span class="new-view__helptext helptext font-normal">
					Collect data
				</span>
			</ElDropdownItem>
		</ElDropdownMenu>
	</ElDropdown>
</template>

  <script lang="ts">
	import { defineComponent } from 'vue';
	import { Dropdown, DropdownMenu, DropdownItem } from '@cognitoforms/element-ui';
	import CToolTip from 'src/components/interaction/ToolTip.vue';

	export default defineComponent({
		name: 'CNewView',
		components: {
			ElDropdown: Dropdown,
			ElDropdownMenu: DropdownMenu,
			ElDropdownItem: DropdownItem,
			CToolTip
		},
		props: {
		},
		methods: {
			newView(type) {
				this.$emit('new-view', type);
			}
		}
	});
  </script>

<style lang="scss">
.new-view {

	&__button {
		transition: var(--duration-hovered);
	}

	&__dropdown-title {
		padding-top: 11px;
		padding-right: 14px;
		padding-bottom: 4px;
		padding-left: 14px;
		font-size: 11.1px;
	}

	&__helptext {
		margin-left: calc($size__icon + $space__icon);
	}
}
</style>